import EdoDashboard from './EdoDashboard';

export default EdoDashboard;
